<template>

    <div class="obras pb-5 ">
       <div class="container">
      
         <div class="slide-n">
                      <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                          <div class="carousel-item text-center" :class="{ 'active': i === 0 }"  v-for="(item,i) in slide" :key="i">
                            <img class="imagen-slide img-fluid" :src="`https://espais.com.py${item}`"  alt="Imagen Noticia">
                          </div>
                    
                        </div>
                          <a v-if="slide.length > 1"  class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                              <i class="fas fa-chevron-left"></i>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a v-if="slide.length > 1"  class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                  <i class="fas fa-chevron-right"></i>
                                <span class="sr-only">Next</span>
                          </a>

                     
                      </div>
         </div>

            <div class="mt-3"><h3>{{home.titulo}}</h3></div>
           <div v-html="home.contenido" class="mt-3"></div>

                   <a v-if="archivo_pdf" :href="archivo_pdf" target="_blank">Descarga Pdf</a>
                    <hr>
          
           <div>{{home.fecha}}</div>
          <div class="my-2 d-flex">
               <div v-on:click="shareOverrideOGMeta(rutaa,titulo,contenido,imagen)" class="facebook-share facebook-color pr-3">
               <i class="fab fa-facebook"></i> Facebook
            </div>
   

            <social-sharing :url="ruta"
                            :title="home.titulo"
                            :description="home.contenido"
                            :quote="home.titulo"
                            hashtags="arquitectura,paraguay,espais"
                            :media="`https://espais.com.py${portada}`"
                            inline-template>
                    <div>
                    <network network="pinterest">
                          <i class="fab fa-pinterest pinterest-color"></i> <span class="pint-text">Pinterest</span>
                        </network>
                    </div>
              </social-sharing>
         </div>
          
      </div>
    </div>
</template>

<style>
.carousel-control-prev, .carousel-control-next{
 font-size: 40px;
 filter: drop-shadow(0 0 7px #000);
 
}


.imagen-slide{
  max-height: 800px;
  
}
</style>

<script>


export default {
     data(){
        return{
            home:{},
            new_data:[],
            page:0,
            portada:'',
            rutaa: '',
            ruta:'',
            titulo:'testa',
            contenido:'www.espais.com.py',
            slide:[],
            imagen:'',
            imagen_dos:'',
            imagen_tres:'',
            archivo_pdf:null
        }
    },
    created(){
            window.fbAsyncInit = function() {
                FB.init({
                  appId            : '2158408504417471',
                  autoLogAppEvents : true,
                  xfbml            : true,
                  version          : 'v2.10'
                });
                FB.AppEvents.logPageView();
            };

            (function(d, s, id){
              var js, fjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) {return;}
              js = d.createElement(s); js.id = id;
              js.src = "//connect.facebook.net/en_US/sdk.js";
              fjs.parentNode.insertBefore(js, fjs);
              }(document, 'script', 'facebook-jssdk'));

    },
    metaInfo: {
    meta: [
          { charset: 'utf-8' },
          {  'name': 'og:title', 'content': 'Titulo para facebook' },
          {  'name': 'og:type', 'content': 'Movie' },
          {  'name': 'og:url', 'content': 'https://espais.com.py/pform/#/' },
        ]
      },
    methods:{
      shareOverrideOGMeta(overrideLink, overrideTitle, overrideDescription, overrideImage){
          console.log("entra al menos");
          	FB.ui({
              method: 'share_open_graph',
              action_type: 'og.likes',
              action_properties: JSON.stringify({
                object: {
                  'og:url': overrideLink,
                  'og:title': overrideTitle,
                  'og:description': overrideDescription,
                  'og:image': overrideImage
                }
              })
            },
            function (response) {
              console.log(response);
            // Action after response
            });
      },
        loadLogs () {
          this.ruta = 'espais.com.py/pform/#'+this.$route.path;
          this.$http.get(`https://espais.com.py/admin/api/1.1/tables/noticias/rows/${this.$route.params.id}`)
        .then(function (data) {
    
          if(data.body.data.archivo_pdf){
            this.archivo_pdf = "https://espais.com.py" + data.body.data.archivo_pdf.data.url;
          }
          this.rutaa = "https://espais.com.py/pform/#/noticia/"+data.body.data.id;
          this.imagen = "https://espais.com.py"+data.body.data.imagen.data.url;

          this.slide[0] = data.body.data.imagen.data.url;
          if(data.body.data.imagen_dos != null){
            this.slide[1] = data.body.data.imagen_dos.data.url;
          }
          if(data.body.data.imagen_tres != null){
             this.slide[2] = data.body.data.imagen_tres.data.url;
          }
          
          
          this.titulo = data.body.data.titulo;
          this.portada = data.body.data.imagen.data.url;
          this.home = data.body.data;
        })
      }
    },
     mounted () {
        this.$nextTick(function () {
        this.loadLogs();
        })
     }
}
</script>




// WEBPACK FOOTER //
// src/components/Noticia.vue